import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import DispatchProps from "../utils/DispatchProps";
import {Doughnut} from "react-chartjs-2";
import {IRootState} from "../store";
import _ from "lodash";
import {WorkUnitStats} from "../models/WorkloadAnalytics";

interface WorkUnitStatsChartsProps {
    workUnitStats: WorkUnitStats[];
}

interface WorkUnitStatsChartsState {
    durationDoughnutData: any;
    statusDoughnutData: any;
    failureDoughnutData: any;
}

class WorkUnitStatsCharts extends Component<WorkUnitStatsChartsProps & DispatchProps, WorkUnitStatsChartsState> {

    constructor(props: WorkUnitStatsChartsProps & DispatchProps) {
        super(props);

        this.state = {
            durationDoughnutData: {},
            statusDoughnutData: {},
            failureDoughnutData: {}
        };
    }

    componentDidMount(): void {
        this.setChartData();
    }

    async componentDidUpdate(prevProps: Readonly<WorkUnitStatsChartsProps & DispatchProps>, prevState: Readonly<WorkUnitStatsChartsState>, snapshot?: any): Promise<void> {

        if(this.props.workUnitStats !== prevProps.workUnitStats)
        {
            this.setChartData();
        }
    }

    private setChartData() {

        const workUnitStatsGroupedByName = _.groupBy(this.props.workUnitStats,i => i.workUnitName);
        
        let durationSumData = Object.keys(workUnitStatsGroupedByName).map((workUnitName) => {
            const values = workUnitStatsGroupedByName[workUnitName];
            const sum =  _.sumBy(values,v => (v.successAverageRunTime * v.successCount));
            
            return {
                workUnitName,
                sum
            };
            
        });
        
        durationSumData = _.sortBy(durationSumData,d => d.sum);
        
        const durationDoughnutData = {
            title: "SUM Duration",
            labels: durationSumData.map(d => d.workUnitName),
            datasets: [{
                data: durationSumData.map(d => d.sum)
            }]
        };


        const successSum = _.sumBy(this.props.workUnitStats,i => i.successCount);
        const partialSuccessSum = _.sumBy(this.props.workUnitStats,i => i.partialSuccessCount);
        const failSum = _.sumBy(this.props.workUnitStats,i => i.failCount);
        
        const statusDoughnutData = {
            title: "Success/Fail",
            labels: ["Success","PartialSuccess","Fail"],
            datasets: [
                {
                    data: [successSum,partialSuccessSum,failSum],
                    backgroundColor: [
                        '#99c140',
                        '#e7b416',
                        '#cc3232'
                    ]
                }
            ]
        }


        let failureSumData = Object.keys(workUnitStatsGroupedByName).map((workUnitName) => {
            const values = workUnitStatsGroupedByName[workUnitName];
            const sum =  _.sumBy(values,v => v.failCount);

            return {
                workUnitName,
                sum
            };

        });
        failureSumData = _.sortBy(failureSumData,d => d.sum);



        const failureDoughnutData = {
            title: "SUM Failure",
            labels: failureSumData.map(d => d.workUnitName),
            datasets: [{
                data: failureSumData.map(d => d.sum)
            }]
        };

        
        this.setState({
            durationDoughnutData,
            statusDoughnutData,
            failureDoughnutData
        });

    }

    render(): JSX.Element {
        return (
            <Fragment>
                <div className="card card">
                    <div className="card__header">
                        <span className={"card__title"}>Work Units (Sampled Data)</span>
                    </div>
                    <div className="card__content flex-column">
                        <div className={"flex-row flex--justify-content-space-around"}>
                            <div className="doughnut-holder">
                                <Doughnut data={this.state.durationDoughnutData} height={1} width={1}  options={
                                    {
                                        legend: {display: false},
                                        title: {
                                            display: true,
                                            text: 'Duration SUM'
                                        }
                                    }
                            }/>
                            </div>
                            <div className="doughnut-holder">
                                <Doughnut data={this.state.statusDoughnutData} height={1} width={1} options={
                                    {
                                        legend: {display: false},
                                        title: {
                                            display: true,
                                            text: 'Status Total'
                                        }
                                    }
                                }/>
                            </div>
                            <div className="doughnut-holder">
                                <Doughnut data={this.state.failureDoughnutData} height={1} width={1}  options={
                                    {
                                        title: {
                                            display: true,
                                            text: 'Failure SUM'
                                        },
                                        legend: {display: false}
                                    }
                                }/>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { workUnitStats: WorkUnitStats[]}): WorkUnitStatsChartsProps => {
        return {
            workUnitStats: ownProps.workUnitStats,
        };
    }
)(WorkUnitStatsCharts)